<template>
  <drawer-section title="Categories" icon="icon-components">
    <template #header-actions>
      <base-button variant="outlined" tone="primary" size="sm" @click.stop="emit('add')">
        <i class="tim-icons icon-simple-add"></i> Add category
      </base-button>
    </template>
    <div v-if="active.length" class="choice-rows">
      <button v-for="c in active" :key="c.id" type="button" class="choice-row" @click="emit('edit', c)">
        <span class="choice-row__dot" :style="{ backgroundColor: c.label_color }" aria-hidden="true"></span>
        <span class="choice-row__body">
          <span class="choice-row__title text-white">{{ c.name }}</span>
          <span class="choice-row__description">{{ c.description || 'No description' }}</span>
        </span>
        <span v-if="hasCheck(c)" class="choice-row__status" :style="{ color: chip(c).color }">
          <i class="tim-icons icon-pin" aria-hidden="true"></i> {{ chip(c).label }}
        </span>
        <span v-else class="choice-row__status choice-row__description">{{ chip(c).label }}</span>
        <i class="tim-icons icon-minimal-right choice-row__chevron" aria-hidden="true"></i>
      </button>
    </div>
    <info-hint v-else variant="neutral" icon="icon-components">No categories yet. Add one to sort time logs by type of work.</info-hint>
  </drawer-section>
</template>

<script setup lang="ts">
// Time tracking categories drawer, list view (OTC-2926): one row per active
// category with its location check status. Clicking a row opens the edit view.
import { computed } from 'vue'
import { locationStatusChip, groupCountry } from '@/util/locationCheck'

type Category = {
  id: number
  name: string
  label_color: string
  description?: string | null
  archived: number
  location_check_mode?: string
  location_radius_m?: number | null
}

const props = defineProps({
  categories: { type: Array as () => Category[], default: () => [] },
})

const emit = defineEmits(['add', 'edit'])

const country = groupCountry()

const active = computed(() => (props.categories || [])
  .filter((c) => Number(c.archived) === 0)
  .sort((a, b) => String(a.name).localeCompare(String(b.name))))

function chip(c: Category) {
  return locationStatusChip(c.location_check_mode, c.location_radius_m, country)
}

function hasCheck(c: Category) {
  return c.location_check_mode === 'warning' || c.location_check_mode === 'block'
}

</script>
